import { Model } from '@vuex-orm/core'

import Journal from './Journal'

class Material extends Model {
  static entity = 'materials'

  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      workspace_id: this.attr(null),
      material_group_id: this.attr(),
      order: this.attr(null),
      hidden: this.attr(null),
      journal_id: this.attr(null),
      journal: this.belongsTo(Journal, 'journal_id'),
      accepted_lifetime: this.attr(null),
    }
  }
}

class MaterialCategory extends Model {
  static entity = 'materialCategories'

  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null),
      meta: this.attr(null),
      order: this.attr(null),
      material_groups: this.hasMany(MaterialGroup, 'material_category_id')
    }
  }
}

class MaterialGroup extends Model {
  static entity = 'materialGroups'

  static fields () {
    return {
      id: this.attr(null),
      material_category_id: this.attr(null),
      material_type_id: this.attr(null),
      material_type: this.belongsTo(MaterialType, 'material_type_id')
    }
  }
}

class MaterialType extends Model {
  static entity = 'materialTypes'

  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null),
      order: this.attr(null),
      capacity: this.attr(null),
      fulfilled: this.attr(null),
      acceptable: this.attr(null),
    }
  }
}

class MaterialAppearance extends Model {
  static entity = 'materialAppearances'

  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null),
      thumbnail_url: this.attr(null),
      parts: this.hasMany(MaterialAppearancePart, 'material_appearance_id'),
      default: this.attr(null),
    }
  }
}

class MaterialAppearancePart extends Model {
  static entity = 'materialAppearanceParts'

  static fields () {
    return {
      id: this.attr(null),
      material_appearance_id: this.attr(null),
      material_type_id: this.attr(null),
      material_type: this.belongsTo(MaterialType, 'material_type_id')
    }
  }
}

export {
  Material,
  MaterialCategory,
  MaterialType,
  MaterialGroup,
  MaterialAppearance,
  MaterialAppearancePart,
}
